export const types = { 
    labourHire: 5,
    cm3: 4,
    iso: 3,
    workCover: 2,
    publicLiability: 1
}